import React, { Component, lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import AuthenticatedRoute from "./AuthenticatedRoute.jsx";
import HeaderComponent from "./HeaderComponent.jsx";
import FooterComponent from "./FooterComponent.jsx";
import AdBanner from "./AdBanner.jsx";
import SEO from "../SEO.jsx";

const LoginComponent = lazy(() => import("./LoginComponent.jsx"));
const ListTodosComponent = lazy(() => import("./ListTodosComponent.jsx"));
const ErrorComponent = lazy(() => import("./ErrorComponent.jsx"));
const LogoutComponent = lazy(() => import("./LogoutComponent.jsx"));
const WelcomeComponent = lazy(() => import("./WelcomeComponent.jsx"));
const TodoComponent = lazy(() => import("./TodoComponent.jsx"));
const QnAJava = lazy(() => import("../questionanswer/QnAJava.jsx"));
const QnA = lazy(() => import("../questionanswer/QnA.jsx"));
const QnAReact = lazy(() => import("../questionanswer/QnAReact.jsx"));
const QnAKafka = lazy(() => import("../questionanswer/QnAKafka.jsx"));
const QnACassandra = lazy(() => import("../questionanswer/QnACassandra.jsx"));
const QnASQL = lazy(() => import("../questionanswer/QnASQL.jsx"));
const AddQuestion = lazy(() => import("../questionanswer/AddQuestion.jsx"));
const Projects = lazy(() => import("../questionanswer/Projects.jsx"));
const InterviewProcess = lazy(() => import("../questionanswer/InterviewProcess.jsx"));
const PrepareForInterview = lazy(() => import("../questionanswer/PrepareForInterview.jsx"));
const QnAPaginationAll = lazy(() => import("../questionanswer/QnAPaginationAll.jsx"));
const StreamAPIBlog = lazy(() => import("../blogs/java/StreamAPIBlog.jsx"));
const PrivacyPolicyMain = lazy(() => import("../privacy/PrivacyPolicyMain.jsx"));
const AddressBookPrivacyPolicy = lazy(() => import("../privacy/AddressBookPrivacyPolicy.jsx"));
const VocabularyAppPrivacyPolicy = lazy(() => import("../privacy/VocabularyAppPrivacyPolicy.jsx"));
const InterviewGuidePrivacyPolicy = lazy(() => import("../privacy/InterviewGuidePrivacyPolicy.jsx"));
const InterviewDojoPrivacyPolicy = lazy(() => import("../privacy/InterviewDojoPrivacyPolicy.jsx"));
const Learn = lazy(() => import("../questionanswer/Learn.jsx"));
const AmazonProducts = lazy(() => import("../affiliates/AmazonProducts"));
const WalmartProducts = lazy(() => import("../affiliates/WalmartProducts"));
const QnASpring = lazy(() => import("../questionanswer/QnASpring.jsx"));
const QnAHibernate = lazy(() => import("../questionanswer/QnAHibernate.jsx"));
const QnAJavaScript = lazy(() => import("../questionanswer/QnAJavaScript.jsx"));
const QnAJava8Features = lazy(() => import("../questionanswer/QnAJava8Features.jsx"));
const DesignPatterns = lazy(() => import("../questionanswer/DesignPatterns.jsx"));
const QnAAmazonWebServices = lazy(() => import("../questionanswer/QnAAmazonWebServices.jsx"));
const QnADataStructureAndAlgorithm = lazy(() => import("../questionanswer/QnADataStructureAndAlgorithm.jsx"));
const QnADocker = lazy(() => import("../questionanswer/QnADocker.jsx"));
const QnAKubernetes = lazy(() => import("../questionanswer/QnAKubernetes.jsx"));
const QnATerraform = lazy(() => import("../questionanswer/QnATerraform.jsx"));
const QnAAzure = lazy(() => import("../questionanswer/QnAAzure.jsx"));
const QnAAWS = lazy(() => import("../questionanswer/QnAAmazonWebServices.jsx"));
const QnAMongoDB = lazy(() => import("../questionanswer/QnAMongoDB.jsx"));
const QnAElasticSearch = lazy(() => import("../questionanswer/QnAElasticSearch.jsx"));
const QnAAngular = lazy(() => import("../questionanswer/QnAAngular.jsx"));
const QnABehavioral = lazy(() => import("../questionanswer/QnABehavioral.jsx"));
const QnAMicroservices = lazy(() => import("../questionanswer/QnAMicroservices.jsx"));
const QnArestAPI = lazy(() => import("../questionanswer/QnArestAPI.jsx"));
const QnASystemDesign = lazy(() => import("../questionanswer/QnASystemDesign.jsx"));
const QnACodingRound = lazy(() => import("../questionanswer/QnACodingRound.jsx"));
const SystemDesign = lazy(() => import("../system-design/SystemDesign.jsx"));
const SystemDesignDetail = lazy(() => import("../system-design/SystemDesignDetail"));
const InterviewGamePlanDetail = lazy(() => import("../system-design/InterviewGamePlanDetail"));
const PerformanceMathSizingDetail = lazy(() => import("../system-design/PerformanceMathSizingDetail"));
const InternetNetworkingFundamentalsDetail = lazy(() => import("../system-design/InternetNetworkingFundamentalsDetail"));
const StorageDatabasesDetail = lazy(() => import("../system-design/StorageDatabasesDetail"));
const CachingDetail = lazy(() => import("../system-design/CachingDetail"));
const MessagingStreamingDetail = lazy(() => import("../system-design/MessagingStreamingDetail"));
const DistributedSystemsTheoryDetail = lazy(() => import("../system-design/DistributedSystemsTheoryDetail"));
const ReliabilityResilienceDetail = lazy(() => import("../system-design/ReliabilityResilienceDetail"));
const ObservabilityOperationsDetail = lazy(() => import("../system-design/ObservabilityOperationsDetail"));
const ApisServiceDesignDetail = lazy(() => import("../system-design/ApisServiceDesignDetail"));
const SecurityPrivacyComplianceDetail = lazy(() => import("../system-design/SecurityPrivacyComplianceDetail"));
const ComputeRuntimeDetail = lazy(() => import("../system-design/ComputeRuntimeDetail"));
const AdvancedPatternsDetail = lazy(() => import("../system-design/AdvancedPatternsDetail"));
const TestingQualityDetail = lazy(() => import("../system-design/TestingQualityDetail"));
const CostEfficiencyDetail = lazy(() => import("../system-design/CostEfficiencyDetail"));
const QnABlind75 = lazy(() => import("../questionanswer/QnABlind75.jsx"));
const ConsulBlog = lazy(() => import("../blogs/ConsulBlog.jsx"));
const CDNBlog = lazy(() => import("../blogs/CDNBlog.jsx"));
const Algorithm = lazy(() => import("../algorithms/Algorithm.jsx"));
const QnASDLC = lazy(() => import("../questionanswer/QnASDLC.jsx"));
const GitBlog = lazy(() => import("../blogs/GitBlog.jsx"));
const LambdaStepFunctionBlog = lazy(() => import("../blogs/LambdaStepFunctionBlog.jsx"));
const AbilityTest = lazy(() => import("../ability-test/AbilityTest.jsx"));
const Blogs = lazy(() => import("../blogs/Blogs.jsx"));
const QnAServiceBus = lazy(() => import("../questionanswer/QnAServiceBus.jsx"));
const CacheBlog = lazy(() => import("../blogs/CacheBlog.jsx"));
const AndroidApp = lazy(() => import("../privacy/AndroidApp.jsx"));
const QnACosmos = lazy(() => import("../questionanswer/QnACosmos.jsx"));
const Companies = lazy(() => import("../companies/Companies.jsx"));
const CompanyDetail = lazy(() => import("../companies/CompanyDetail.jsx"));
const Quiz = lazy(() => import("../ability-test/Quiz.jsx"));
const QuizApp = lazy(() => import("../ability-test/QuizApp.jsx"));
const QnAJavalin = lazy(() => import("../questionanswer/QnAJavalin.jsx"));
const JsonSearch = lazy(() => import("../questionanswer/search/JsonSearch.jsx"));
const RabinProfile = lazy(() => import("../profile/rabin"));
const KhusbuProfile = lazy(() => import("../profile/khusbu"));
const QnAPython = lazy(() => import("../questionanswer/QnAPython.jsx"));
const JavaQuiz = lazy(() => import("../abilityTest/JavaQuiz.jsx"));
const JavaScriptQuiz = lazy(() => import("../abilityTest/JavaScriptQuiz.jsx"));
const SQLQuiz = lazy(() => import("../abilityTest/SQLQuiz.jsx"));
const CollectionAPIQuiz = lazy(() => import("../abilityTest/CollectionAPIQuiz.jsx"));
const SpringQuiz = lazy(() => import("../abilityTest/SpringQuiz.jsx"));
const HibernateQuiz = lazy(() => import("../abilityTest/HibernateQuiz.jsx"));
const ReactJS = lazy(() => import("../abilityTest/ReactJS.jsx"));
const Angular = lazy(() => import("../abilityTest/Angular.jsx"));
const Java8 = lazy(() => import("../abilityTest/Java8.jsx"));
const ContactUs = lazy(() => import("../questionanswer/ContactUs.jsx"));
const Badge = lazy(() => import("../questionanswer/Badge.jsx"));
const QnACSharp = lazy(() => import("../questionanswer/QnACSharp.jsx"));
const QnAArtificialIntelligence = lazy(() => import("../questionanswer/QnAArtificialIntelligence.jsx"));
const Career = lazy(() => import("./Career"));
const PythonQuiz = lazy(() => import("../abilityTest/PythonQuiz.jsx"));
const KafkaQuiz = lazy(() => import("../abilityTest/KafkaQuiz.jsx"));
const CassandraQuiz = lazy(() => import("../abilityTest/CassandraQuiz.jsx"));
const ResumeChecker = lazy(() => import("../resume/ResumeChecker.jsx"));

class TodoApp extends Component {
  render() {
    return (
      <div className="TodoApp">
        <Router>
          <>
            <SEO />
            <HeaderComponent />

            <Suspense fallback={<div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading…</span></div></div>}>
              <Switch>
              <Route path="/" exact component={QnA} />
              <Route path="/login" component={LoginComponent} />
              <AuthenticatedRoute
                path="/welcome/:name"
                component={WelcomeComponent}
              />
              <AuthenticatedRoute path="/todos/:id" component={TodoComponent} />
              <AuthenticatedRoute
                path="/todos"
                component={ListTodosComponent}
              />
              <AuthenticatedRoute path="/logout" component={LogoutComponent} />
              <AuthenticatedRoute
                path="/addQuestion/:id"
                component={AddQuestion}
              />
              <Route path="/home" component={QnA} />
              <Route path="/questions" component={QnAJava} />
              <Route path="/java" component={QnAJava} />
              <Route path="/kafka" component={QnAKafka} />
              <Route path="/python" component={QnAPython} />
              <Route path="/cassandra" component={QnACassandra} />
              <Route path="/react" component={QnAReact} />
              <Route path="/sql" component={QnASQL} />
              <Route path="/spring" component={QnASpring} />
              <Route path="/cSharp" component={QnACSharp} />
              <Route path="/artificialIntelligence" component={QnAArtificialIntelligence} />
              
              <Route path="/hibernate" component={QnAHibernate} />
              <Route path="/javascript" component={QnAJavaScript} />
              <Route path="/java8features" component={QnAJava8Features} />
              <Route path="/designPatterns" component={DesignPatterns} />
              <Route path="/blind75" component={QnABlind75} />
              <Route path="/consul" component={ConsulBlog} />
              <Route path="/cdn" component={CDNBlog} />
              <Route path="/algorithms" component={Algorithm} />
              <Route path="/sdlc" component={QnASDLC} />
              <Route path="/git" component={GitBlog} />
              <Route path="/lambdaAndStepFunction" component={LambdaStepFunctionBlog} />
              <Route path="/proficiencyTest" component={AbilityTest} />
              <Route path="/blogs" component={Blogs} />
              <Route path="/serviceBus" component={QnAServiceBus} />
              <Route path="/cache" component={CacheBlog} />
              <Route path="/mobileApps" component={AndroidApp} />
              <Route path="/quiz" component={Quiz} />
              <Route path="/quizApp" component={QuizApp} />
              
              <Route path="/javaQuiz" component={JavaQuiz} />
              <Route path="/javascriptQuiz" component={JavaScriptQuiz} />
              <Route path="/sqlQuiz" component={SQLQuiz} />
              <Route path="/collectionApiQuiz" component={CollectionAPIQuiz} />
              <Route path="/springQuiz" component={SpringQuiz} />
              <Route path="/hibernateQuiz" component={HibernateQuiz} />
              <Route path="/reactJSQuiz" component={ReactJS} />
              <Route path="/angularQuiz" component={Angular} />
              <Route path="/java8Quiz" component={Java8} />

              <Route path="/pythonProficiencyTest" component={PythonQuiz} />
              <Route path="/kafkaProficiencyTest" component={KafkaQuiz} />
              <Route path="/cassandraProficiencyTest" component={CassandraQuiz} />
            

              <Route
                path="/amazonWebServices"
                component={QnAAmazonWebServices}
              />
              <Route path="/dsa" component={QnADataStructureAndAlgorithm} />
              <Route path="/kubernetes" component={QnAKubernetes} />
              <Route path="/docker" component={QnADocker} />
              <Route path="/terraform" component={QnATerraform} />
              <Route path="/azure" component={QnAAzure} />
              <Route path="/aws" component={QnAAWS} />
              <Route path="/mongoDB" component={QnAMongoDB} />
              <Route path="/elasticSearch" component={QnAElasticSearch} />
              <Route path="/angular" component={QnAAngular} />
              <Route path="/microservices" component={QnAMicroservices} />
              <Route path="/behavioral" component={QnABehavioral} />
              <Route path="/restAPI" component={QnArestAPI} />
              <Route path="/systemDesignInterviewQuestions" component={QnASystemDesign} />
              <Route path="/codingRound" component={QnACodingRound} />
              <Route path="/systemDesign" component={SystemDesign} />
              <Route exact path="/companies" component={Companies} />
              <Route path="/companies/:slug" component={CompanyDetail} />
              <Route path="/resumeChecker" component={ResumeChecker} />

                {/* specific pages FIRST */}
                <Route
                  exact
                  path="/interview-game-plan"
                  component={InterviewGamePlanDetail}
                />

                {/* list page */}
                <Route exact path="/systemDesign" component={SystemDesign} />

                {/* generic catch-all LAST */}
                <Route path="/systemDesign/:slug" component={SystemDesignDetail} />

               <Route exact path="/performance-math-and-sizing" component={PerformanceMathSizingDetail} />

               <Route exact path="/internet-and-networking-fundamentals" component={InternetNetworkingFundamentalsDetail} />

              <Route exact path="/storage-and-databases" component={StorageDatabasesDetail} />

              <Route exact path="/caching" component={CachingDetail} />

              <Route exact path="/messaging-and-streaming" component={MessagingStreamingDetail} />

              <Route exact path="/distributed-systems-theory" component={DistributedSystemsTheoryDetail} />

              <Route exact path="/reliability-and-resilience" component={ReliabilityResilienceDetail} />

              <Route exact path="/observability-and-operations" component={ObservabilityOperationsDetail} />

              <Route exact path="/apis-and-service-design" component={ApisServiceDesignDetail} />

              <Route exact path="/security-privacy-compliance" component={SecurityPrivacyComplianceDetail} />

              <Route exact path="/compute-and-runtime" component={ComputeRuntimeDetail} />

              <Route exact path="/advanced-patterns" component={AdvancedPatternsDetail} />

              <Route exact path="/testing-and-quality-at-scale" component={TestingQualityDetail} />

              <Route exact path="/cost-and-efficiency" component={CostEfficiencyDetail} />

              <Route path="/cosmos" component={QnACosmos} />
              <Route path="/javalin" component={QnAJavalin} />
              {/* <Route path="/selenium" component={QnASelenium} /> */}
              <Route path="/projects" component={Projects} />
              <Route path="/interviewProcess" component={InterviewProcess} />
              <Route path="/all" component={QnAPaginationAll} />
              <Route path="/privacyPolicyMain" component={PrivacyPolicyMain} />
              <Redirect from="/about" to="/home" />
              <Redirect from="/aboutUs" to="/home" />
              <Redirect from="/aboutTechVentureLLC" to="/home" />
              <Route path="/contactUs" exact component={ContactUs} />
              <Route path="/badges" exact component={Badge} />
              <Route path="/search" component={JsonSearch} />
              <Route exact path="/profile/rabin-pantha" component={RabinProfile} />
              <Route exact path="/profile/khusbu-thapa" component={KhusbuProfile} />
              <Route path="/learn" component={Learn} />
              <Route path="/career" component={Career} />
              <Route
                path="/addressBookPrivacyPolicy"
                component={AddressBookPrivacyPolicy}
              />
              <Route
                path="/vocabularyAppPrivacyPolicy"
                component={VocabularyAppPrivacyPolicy}
              />
              <Route
                path="/interviewDojoApp"
                component={InterviewGuidePrivacyPolicy}
              />
              <Route
                path="/interviewDojoPrivacyPolicy"
                component={InterviewDojoPrivacyPolicy}
              />
              <Route path="/blog/java/streamAPI" component={StreamAPIBlog} />
              <Route
                path="/prepareForInterview"
                component={PrepareForInterview}
              />
              <Route path="/amazonProducts" component={AmazonProducts} />
              <Route path="/walmartProducts" component={WalmartProducts} />
              <Route component={ErrorComponent} />
              </Switch>
            </Suspense>
            <FooterComponent />
            <AdBanner />
          </>
        </Router>
        {/*<LoginComponent/>
                <WelcomeComponent/>*/}
      </div>
    );
  }
}

export default TodoApp;
